import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: ["price-override-container"] },
    [
      _vm.useTransitionPeriodOverrideStyling
        ? _c(
            VIcon,
            {
              staticClass: "transition-period-override",
              attrs: { "x-small": "" },
            },
            [_vm._v("fa fa-snowflake-o")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "price-value": true,
            "transition-period-override":
              _vm.useTransitionPeriodOverrideStyling,
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.priceForDisplay) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }